import {Component, OnInit, ViewContainerRef} from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import {TranslateService} from '@ngx-translate/core';
import {LocalStorageService} from './services/local-storage.service';
import {ActivatedRoute, NavigationError, Router, RoutesRecognized} from '@angular/router';
import {forEach} from '@angular/router/src/utils/collection';
import {isUndefined} from 'util';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {

    supportedLanguages = ['en', 'da'];
    indexPath = 'sites';
    areRviewsLoaded = false;

    constructor(
        private translateService: TranslateService,
        private toastr: ToastsManager,
        private router: Router,
        vcr: ViewContainerRef) {
        // this language will be used as a fallback when a translation isn't found in the current language
        this.translateService.setDefaultLang('en');

        this.router.events.subscribe(event => {

            if (event instanceof RoutesRecognized) {

                // Check if the path is only a langCode
                const url = event.url.substring(1, event.url.length);
                if (this.isLanguageSupported(url)) {
                    const path = url + '/' + this.indexPath;
                    this.translateService.use(url);
                    this.router.navigate([path]);
                    return;
                }

                const activatedRoute = event.state.root.firstChild;
                const routeLang = activatedRoute.params['langCode'];

                if (this.isLanguageSupported(routeLang) && routeLang !== this.translateService.currentLang) {
                    this.translateService.use(routeLang);
                }
            }
        });

        this.toastr.setRootViewContainerRef(vcr);
    }

    private isLanguageSupported(lang: string) {
        return this.supportedLanguages.indexOf(lang) > -1;
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/app.component.ts